import React from 'react'
import MaterialIcons from 'material-icons-react'
import './style.css'
import Mapa from './mapa/container'
import ControlBar from './controlbar/container'

export default class Vendas extends React.Component{

    componentDidMount(){
        console.log('console.log(this.control)', this.controls)
    }

    setLote = (n) => (this.controls.setLote(n), this.openDetails())
    toggleDetails = () => this.controls.toggle()
    openDetails = () => this.controls.open()
    
    render(){
        

        return(
            <div className='vendas_container'>
        
                <h3 className='vendas_titulo'> Estado de vendas e mapa 
                <span className='action_button' onClick={this.toggleDetails}>
                    <MaterialIcons icon={'add'} size={35}/></span>
                </h3>

                <ControlBar ref={e => e?this.controls = e.getWrappedInstance():null}/>

                <hr className='page_content_divider'/>

                <div className='mapa_container'>
                    <Mapa setLote={this.setLote} ref={e => e?this.mapa_ = e.getWrappedInstance():null}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/component.js